module.exports = __webpack_public_path__ + "media/customizations/eaglecreek/back-c825cbb8c5323c4994f77ea6a16189f1.jpg";